module.exports = __webpack_public_path__ + "favicon.ico";


/*****************
 ** WEBPACK FOOTER
 ** ./~/file-loader?name=favicon.ico!./app/static/favicon.ico
 ** module id = 930
 ** module chunks = 0
 **/